import { createSlice } from "@reduxjs/toolkit";

interface State {
    tenancyName: string,
}
interface Action {
    type: string,
    payload: State
}

const tenantSlice = createSlice({
    name: "tenantSlice",
    initialState: {
        tenancyName: "",
    },
    reducers: {
        setTenancyName(state: State, action: Action) {
            state.tenancyName = action.payload.tenancyName;
        },
          // ✅ Clear tenancy name
        clearTenancyName(state: State) {
            state.tenancyName = "";
        }
    }
});

export const { setTenancyName, clearTenancyName  } = tenantSlice.actions;
export default tenantSlice.reducer;